/* Tropical Distillery theme — small, dependency-free enhancements.
   Every feature degrades to a plain HTML form or link without JS. */
(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const session = {
    get(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { sessionStorage.setItem(k, v); } catch (e) { /* storage blocked */ } },
  };

  /* ---------- Age gate ---------- */
  const AGE_KEY = 'td-age-verified';
  const gate = $('[data-age-gate]');
  let ageVerified = !gate;
  if (gate) {
    try { ageVerified = localStorage.getItem(AGE_KEY) === '1'; } catch (e) { /* storage blocked */ }
    if (!ageVerified) {
      gate.hidden = false;
      document.body.classList.add('is-locked');
      $('[data-age-confirm]', gate)?.focus();
    }
    $('[data-age-confirm]', gate)?.addEventListener('click', () => {
      try { localStorage.setItem(AGE_KEY, '1'); } catch (e) { /* storage blocked */ }
      gate.hidden = true;
      document.body.classList.remove('is-locked');
      document.dispatchEvent(new CustomEvent('theme:age-verified'));
    });
  }

  /* ---------- First-order offer pop-up ---------- */
  const WELCOME_KEY = 'td-welcome';
  const welcome = $('[data-welcome]');
  if (welcome) {
    let seen = null;
    try { seen = localStorage.getItem(WELCOME_KEY); } catch (e) { /* storage blocked */ }
    const openWelcome = () => {
      if (!gate || gate.hidden) {
        welcome.hidden = false;
        document.body.classList.add('is-locked');
        $('input[type="email"], [data-welcome-close]', welcome)?.focus();
      }
    };
    const closeWelcome = () => {
      welcome.hidden = true;
      document.body.classList.remove('is-locked');
      try { localStorage.setItem(WELCOME_KEY, seen === 'joined' ? 'joined' : 'dismissed'); } catch (e) { /* storage blocked */ }
    };
    const justJoined = $('[data-welcome-success]', welcome) && session.get('td-welcome-submitted') === '1';
    if (justJoined) {
      seen = 'joined';
      session.set('td-welcome-submitted', '0');
      try { localStorage.setItem(WELCOME_KEY, 'joined'); } catch (e) { /* storage blocked */ }
      openWelcome();
    } else if (!seen) {
      const schedule = () => setTimeout(openWelcome, Number(welcome.dataset.delay || 6000));
      if (ageVerified) schedule(); else document.addEventListener('theme:age-verified', schedule, { once: true });
    }
    welcome.addEventListener('click', (e) => { if (e.target.closest('[data-welcome-close]')) closeWelcome(); });
    $('form', welcome)?.addEventListener('submit', () => session.set('td-welcome-submitted', '1'));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !welcome.hidden) closeWelcome(); });
  }

  /* ---------- Mobile menu ---------- */
  const menu = $('[data-mobile-menu]');
  $$('[data-menu-toggle]').forEach((btn) => btn.addEventListener('click', () => {
    const open = !menu.classList.contains('is-open');
    menu.classList.toggle('is-open', open);
    document.body.classList.toggle('is-locked', open);
    $$('[data-menu-toggle]').forEach((b) => b.setAttribute('aria-expanded', String(open)));
  }));

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', (e) => {
    const step = e.target.closest('[data-qty-step]');
    if (!step) return;
    const input = step.parentElement.querySelector('input');
    const next = Math.max(Number(input.min || 0), Number(input.value || 1) + Number(step.dataset.qtyStep));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Cart drawer ---------- */
  const drawer = $('[data-cart-drawer]');
  const openDrawer = () => {
    if (!drawer) return;
    drawer.classList.add('is-open');
    document.body.classList.add('is-locked');
    $('[data-drawer-close]', drawer)?.focus();
  };
  const closeDrawer = () => {
    drawer?.classList.remove('is-open');
    document.body.classList.remove('is-locked');
  };
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-drawer-close]')) closeDrawer();
    const trigger = e.target.closest('[data-cart-trigger]');
    if (trigger && drawer && window.theme?.cartDrawer) { e.preventDefault(); openDrawer(); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    closeDrawer();
    if (menu?.classList.contains('is-open')) $('[data-menu-toggle]')?.click();
  });

  /* State check: remembered for the session and re-applied after each re-render */
  const STATE_KEY = 'td-ship-state';
  const showState = () => {
    const wrap = $('[data-state-check]');
    if (!wrap) return;
    const select = $('[data-state-select]', wrap);
    const result = $('[data-state-result]', wrap);
    const state = session.get(STATE_KEY) || '';
    select.value = state;
    if (!state) { result.hidden = true; return; }
    const list = (wrap.dataset.shipStates || '').split(',').map((s) => s.trim().toLowerCase()).filter(Boolean);
    result.hidden = false;
    result.classList.remove('is-ok', 'is-no');
    if (!list.length) {
      result.textContent = `Delivery to ${state} is confirmed at checkout. A 21+ adult signature is required.`;
    } else if (list.includes(state.toLowerCase())) {
      result.classList.add('is-ok');
      result.textContent = `✓ We ship to ${state}. A 21+ adult signature is required.`;
    } else {
      result.classList.add('is-no');
      result.textContent = `Sorry, we can’t ship spirits to ${state} yet. Merch ships anywhere in the U.S.`;
    }
  };
  showState();
  document.addEventListener('change', (e) => {
    const select = e.target.closest('[data-state-select]');
    if (!select) return;
    session.set(STATE_KEY, select.value);
    showState();
  });

  const renderCart = async () => {
    const res = await fetch(`${window.theme.routes.root}?sections=cart-drawer`);
    const data = await res.json();
    const html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
    const fresh = $('[data-cart-drawer-inner]', html);
    const current = $('[data-cart-drawer-inner]');
    if (fresh && current) current.replaceWith(fresh);
    const count = Number(fresh?.dataset.count || 0);
    $$('[data-cart-count]').forEach((el) => { el.textContent = count; el.hidden = count === 0; });
    showState();
  };

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-product-form]');
    if (!form || !window.theme?.cartDrawer || !drawer) return;
    e.preventDefault();
    const button = $('[type="submit"]', form);
    const label = button?.innerHTML;
    if (button) { button.disabled = true; button.textContent = 'Adding…'; }
    try {
      const res = await fetch(window.theme.routes.cartAdd, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.description || 'Could not add to cart.');
      }
      await renderCart();
      openDrawer();
    } catch (err) {
      alert(err.message);
    } finally {
      if (button) { button.disabled = false; button.innerHTML = label; }
    }
  });

  document.addEventListener('change', async (e) => {
    const input = e.target.closest('[data-line-qty]');
    if (!input) return;
    await fetch(window.theme.routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(input.dataset.lineQty), quantity: Number(input.value) }),
    });
    if (input.closest('[data-cart-drawer]')) await renderCart();
    else window.location.reload();
  });

  document.addEventListener('click', (e) => {
    const remove = e.target.closest('[data-line-remove]');
    if (!remove) return;
    e.preventDefault();
    const input = document.querySelector(`[data-line-qty="${remove.dataset.lineRemove}"]`);
    if (input) { input.value = 0; input.dispatchEvent(new Event('change', { bubbles: true })); }
  });

  /* Gift bag checkbox: adds the gift bag, or removes its line */
  document.addEventListener('change', async (e) => {
    const toggle = e.target.closest('[data-gift-bag-toggle]');
    if (!toggle) return;
    toggle.disabled = true;
    const line = Number(toggle.dataset.line || 0);
    if (toggle.checked && !line) {
      await fetch(window.theme.routes.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(toggle.dataset.variantId), quantity: 1 }] }),
      });
    } else if (!toggle.checked && line) {
      await fetch(window.theme.routes.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity: 0 }),
      });
    }
    await renderCart();
  });

  /* Gift message: saved as the cart note */
  document.addEventListener('change', (e) => {
    const note = e.target.closest('[data-cart-note]');
    if (!note) return;
    fetch(window.theme.routes.cartUpdate, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: note.value }),
    });
  });

  /* ---------- Product gallery + variants ---------- */
  $$('[data-product]').forEach((root) => {
    const main = $('[data-main-media]', root);
    $$('[data-thumb]', root).forEach((thumb) => thumb.addEventListener('click', () => {
      const img = $('img', main);
      img.src = thumb.dataset.src;
      img.srcset = thumb.dataset.srcset;
      img.alt = thumb.dataset.alt;
      $$('[data-thumb]', root).forEach((t) => t.setAttribute('aria-current', String(t === thumb)));
    }));

    const select = $('[data-variant-select]', root);
    select?.addEventListener('change', () => {
      const opt = select.selectedOptions[0];
      const idInput = $('[data-variant-id]', root);
      if (idInput) idInput.value = select.value;
      $$('[data-price]').forEach((el) => { el.textContent = opt.dataset.price; });
      const buttons = $$('[data-add-button]');
      buttons.forEach((b) => {
        b.disabled = opt.dataset.available !== 'true';
        b.textContent = opt.dataset.available === 'true' ? 'Add to Cart' : 'Sold Out';
      });
      const url = new URL(window.location.href);
      url.searchParams.set('variant', select.value);
      window.history.replaceState({}, '', url);
    });
  });

  /* Sticky add-to-cart bar on mobile */
  const stickyBar = $('[data-sticky-atc]');
  const mainButton = $('[data-product] [data-add-button]');
  if (stickyBar && mainButton && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      stickyBar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
    }).observe(mainButton);
    $('[data-sticky-add]', stickyBar)?.addEventListener('click', () => mainButton.click());
  }

  /* ---------- Recipe filter chips ---------- */
  $$('[data-recipe-filter]').forEach((wrap) => {
    const chips = $$('[data-filter]', wrap);
    const cards = $$('[data-recipe-flavor]');
    chips.forEach((chip) => chip.addEventListener('click', () => {
      const value = chip.dataset.filter;
      chips.forEach((c) => c.setAttribute('aria-pressed', String(c === chip)));
      cards.forEach((card) => { card.hidden = value !== 'all' && card.dataset.recipeFlavor !== value; });
    }));
  });

  /* ---------- Merch filter chips ---------- */
  $$('[data-merch-shop]').forEach((shop) => {
    const chips = $$('[data-merch-filter]', shop);
    chips.forEach((chip) => chip.addEventListener('click', () => {
      const value = chip.dataset.merchFilter;
      chips.forEach((c) => c.setAttribute('aria-pressed', String(c === chip)));
      $$('[data-merch-category]', shop).forEach((card) => { card.hidden = value !== 'all' && card.dataset.merchCategory !== value; });
      $$('[data-merch-group]', shop).forEach((group) => { group.hidden = !$$('[data-merch-category]:not([hidden])', group).length; });
    }));
  });

  /* ---------- Reels: load near the viewport, play only while visible ---------- */
  const reels = $$('[data-reel]');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const loadReel = (video) => {
    const source = $('source[data-src]', video);
    if (source) { source.src = source.dataset.src; source.removeAttribute('data-src'); video.load(); }
  };
  if (reels.length && 'IntersectionObserver' in window) {
    const reelObserver = new IntersectionObserver((entries) => entries.forEach(({ target, isIntersecting }) => {
      if (isIntersecting) {
        loadReel(target);
        if (!reduceMotion) target.play().catch(() => {});
      } else if (!target.paused) {
        target.pause();
      }
    }), { rootMargin: '200px 0px', threshold: 0.25 });
    reels.forEach((v) => reelObserver.observe(v));
  } else {
    reels.forEach((v) => { loadReel(v); if (!reduceMotion) v.autoplay = true; });
  }

  /* ---------- Reveal on scroll ---------- */
  const reveals = $$('.reveal');
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
    }), { rootMargin: '0px 0px -8% 0px' });
    reveals.forEach((el) => io.observe(el));
  } else {
    reveals.forEach((el) => el.classList.add('is-visible'));
  }
})();